import { Component, EventEmitter, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { GbrechtService, RechtSearchRechteIdRequestMeta } from '../../../../core/gb-api';
import { FormsModule, NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { GbAmtSearchMode as GbAmtSearchMode } from '../../../../shared/widgets/gb-amt/gbAmtSearchMode';
import { submit } from '../recht.functions';
import { GbAmtComponent } from '../../../../shared/widgets/gb-amt/gb-amt.component';
import { TimepointService } from '../../../../core/services/timepoint.service';
import { Subscription } from 'rxjs';
import { AbstractSearchComponent } from '../../../../shared/components/abstract-component/abstract-search.component';
import { SearchStateService } from '../../../../shared/services/search-state.service';
import { SearchMode } from '../../../../shared/enum/searchMode';
import { MetaDirective } from '../../../../shared/directives/meta.directive';
import { CapFormRowDirective } from '../../../../shared/form-control/cap-form-row.directive';
import { CapFormControlComponent } from '../../../../shared/form-control/form-control.component';
import { MetaDisablerDirective } from '../../../../shared/directives/meta-disabler.directive';
import { MetaValidatorDirective } from '../../../../shared/directives/meta-validator.directive';
import { RechteSelectionComponent } from '../../../../shared/widgets/rechte-selection/rechte-selection.component';
import { HistoryOptionsComponent } from '../../../../shared/widgets/history-options/history-options.component';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'cap-recht-suche-rechteid',
  templateUrl: './recht-suche-rechteid.component.html',
  styleUrls: ['./recht-suche-rechteid.component.scss'],
  imports: [
    FormsModule,
    MetaDirective,
    CapFormRowDirective,
    CapFormControlComponent,
    GbAmtComponent,
    MetaDisablerDirective,
    MetaValidatorDirective,
    RechteSelectionComponent,
    HistoryOptionsComponent,
    TranslatePipe
  ]
})
export class RechtSucheRechteidComponent extends AbstractSearchComponent implements OnInit, OnDestroy {
  rechteId: RechtSearchRechteIdRequestMeta;

  @Output()
  tabErweitertActive: EventEmitter<boolean> = new EventEmitter<boolean>();

  @ViewChild(GbAmtComponent, { static: false })
  private gbAmt: GbAmtComponent;

  @ViewChild('form', { static: false })
  form: NgForm;

  gbAmtSearchMode = GbAmtSearchMode.RECHTE_REGISTER_SEARCH;
  private subscription: Subscription;

  constructor(
    stateService: SearchStateService,
    private rechtService: GbrechtService,
    private route: ActivatedRoute,
    private router: Router,
    private timepointService: TimepointService
  ) {
    super(stateService);
  }

  ngOnInit() {
    this.subscription = this.rechtService.searchRechteIdTemplate().subscribe((template) => {
      this.tabErweitertActive.emit(template.mHasRightMassenabfrage.access === 'NONE');
      this.rechteId = this.copyLastRequest(template);
    });
  }

  onSubmit(): void {
    this.timepointService.resetTimepoint();
    this.stateService.lastRequest = this.rechteId;
    submit(this.form, SearchMode.searchStandard, this.rechteId, this.router, this.route);
  }

  onReset() {
    this.form.reset();
    this.subscription = this.rechtService.searchRechteIdTemplate().subscribe((template) => {
      this.rechteId = template;
      this.gbAmt.focus();
    });
  }

  emptyAmtSearch() {
    this.gbAmt.onClear();
  }

  onSelectGbAmt(focusElement) {
    focusElement.focus();
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }
}
